import {
  Box,
  Button,
  Div,
  H5,
  P,
  PosIcon,
  lightTheme,
} from '@vgrubs/components';

type Props = {
  onOpen: () => void;
};

/**
 * The card at the top of Manage Providers that opens the playbook, so someone
 * doing their first connection sees that the rules are written down.
 */
export const IntegrationPlaybookEntry = ({ onOpen }: Props) => (
  <Box $mb="16" $flex $alignCenter $between $gap="16px" $gapSM="12px">
    <Div $flex $alignCenter $gap="16px" $gapSM="12px">
      <PosIcon />
      <Div>
        <H5 $m="0">Integration playbook</H5>
        <P $m="0" $color={lightTheme.lightGray}>
          Rules and timings for POS and marketplace connections.
        </P>
      </Div>
    </Div>
    <Button $small $selected $w="150px" onClick={onOpen}>
      Open playbook
    </Button>
  </Box>
);
